export const formatTimeZone = (
  tz: null | string,
  timezoneOffset: null | string,
): string => {
  if (!tz) return "";

  const city = tz.split("/")[1]?.replace("_", " ") ?? tz;
  const zoneName = `(GMT${timezoneOffset})`;

  return `${city} ${zoneName}`;
};
